<template>
  <div class="bg-white">
    <div class="row no-gutters commodity_area">
      <img class="img" :src="img"  loading="lazy" alt/>
      <div class="img_space"/>
      <div class="info_area">
        <div class="title">【{{ name }}<span v-if="hasSubtitle">/{{ subtitle }}</span>】</div>
        <div style="height: 8px"/>
        <div class="info">{{ info }}</div>
        <div class="info_space"/>
        <div class="row no-gutters price_amount_area">
          <div class="row no-gutters price_area">
            <div :class="{'price': true, 'discounted': this.hasDiscount}">NT${{ priceText }}</div>
            <div v-if="hasDiscount" class="price">NT${{ discountPrice }}</div>
          </div>
          <div class="price_space"/>
          <div class="row no-gutters count_area">
            <div class="row no-gutters text-center amount_area">
              <button class="btn_style btn_left btn_amount" @click="clickDec">
                <img class="icon" src="/img/image/icon/commodity_dec.png" loading="lazy" alt/>
              </button>
              <span class="col amount_text">{{ quantity }}</span>
              <button class="btn_style btn_right btn_amount" @click="clickAdd">
                <img class="icon" src="/img/image/icon/commodity_add.png" loading="lazy" alt/>
              </button>
            </div>

            <div class="btn_space"/>

            <div class="col-auto price">NT${{ subtotalText }}</div>
          </div>
          <div style="width: 30px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getMediaUrl, getPrice, isEmpty} from "../util/helpers";

export default {
  name: "Commodity",
  computed: {
    img() {
      let val = this.value;
      return isEmpty(val) ? "" : getMediaUrl(val, "Order");
    },
    name() {
      return this.value.name;
    },
    hasSubtitle() {
      return isEmpty(this.subtitle) === false;
    },
    subtitle() {
      return this.value.subtitle;
    },
    info() {
      return this.value.info;
    },
    price() {
      let val = this.value.price;
      return isEmpty(val) ? 0 : val;
    },
    priceText() {
      return this.hasDiscount ? getPrice(this.originPrice) : getPrice(this.price);
    },
    originPrice() {
      let val = this.value.origin_price;
      return isEmpty(val) ? 0 : val;
    },
    discountPrice() {
      return getPrice(this.price);
    },
    hasDiscount() {
      if (this.originPrice <= this.price) {
        return false;
      } else {
        return true;
      }
    },
    subtotal() {
      if (this.hasDiscount) {
        return this.discountPrice * this.value.quantity;
      } else {
        return this.price * this.value.quantity;
      }
    },
    subtotalText() {
      return getPrice(this.subtotal);
    },
    quantity() {
      let val = this.value.quantity;
      if (isEmpty(val)) {
        this.value.quantity = 0
      }
      return this.value.quantity;
    },
  },
  props: {
    value: Object,
  },
  data() {
    return {};
  },
  methods: {
    clickAdd() {
      if (this.value.quantity < 100) {
        const newQuantity = this.value.quantity + 1;
        this.$emit('input', {
          ...this.value,
          quantity: newQuantity
        });
      }
    },
    clickDec() {
      if (this.value.quantity > 0) {
        const newQuantity = this.value.quantity - 1;
        this.$emit('input', {
          ...this.value,
          quantity: newQuantity
        });
      }
    },
  },
}
</script>

<style scoped>
.commodity_area {
  padding: 32px 12px 32px 20px;
}

@media (max-width: 768px) {
  .commodity_area {
    padding: 12px;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
}


.img {
  width: 185px;
  height: 135px;
}

@media (max-width: 768px) {
  .img {
    width: 185px;
    height: 135px;
  }
}

.img_space {
  width: 12px;
}

@media (max-width: 768px) {
  .img_space {
    width: 0;
    height: 24px;
  }
}

.info_area {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

@media (max-width: 768px) {
  .info_area {
    width: 100%;
    max-width: none;
    flex-grow: unset;
    flex-basis: unset;
  }
}

.title {
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.info {
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 350;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

@media (max-width: 768px) {
  .info {
    padding-right: 12px;
    padding-left: 12px;
  }
}

.info_space {
  height: 35px;
}

@media (max-width: 768px) {
  .info_space {
    height: 8px;
  }
}


.price_amount_area {
  align-items: center;
}

@media (max-width: 768px) {
  .price_amount_area {
    flex-direction: column;
    align-items: start;
    padding-left: 12px;
    padding-right: 12px;
  }
}

.price_area {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

@media (max-width: 768px) {
  .price_area {
    max-width: none;
    flex-grow: unset;
    flex-basis: unset;
  }
}

.price {
  font-family: Noto Sans TC;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333333;
}

.discounted {
  color: #D5D5D5;
  text-decoration: line-through; /* 删除线 */
  margin-right: 12px;
}

.price_space {
  height: 0;
}

@media (max-width: 768px) {
  .price_space {
    height: 24px;
  }
}

.count_area {
  max-width: 280px;
  width: 280px;
  justify-content: space-between;
}

@media (max-width: 1024px) {
  .count_area {
    width: 50%;
  }
}

@media (max-width: 768px) {
  .count_area {
    max-width: 100%;
    width: 100%;
    flex-direction: column;
    align-items: end;
  }
}


.amount_area {
  width: 112px;
  height: 24px;
  border: 1px solid #B1B1B1;
  box-sizing: content-box;
}

@media (max-width: 768px) {
  .amount_area {
    max-width: 100%;
    width: 100%;
  }
}

.btn_amount {
  width: 24px;
  height: 24px;
  border-radius: 0;
  color: #B1B1B1;
  padding: 0;
  margin: 0;
  line-height: 0;
}

.btn_style {
  position: relative;
  text-transform: uppercase;
  user-select: none;
  background-color: transparent;
  cursor: pointer;
  border: none;
}

.btn_style:focus {
  position: relative;
  text-transform: uppercase;
  user-select: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
}


.icon {
  width: 15px;
  height: 15px;
}


.btn_left {
  border-right: 1px solid #B1B1B1;
}

.btn_right {
  border-left: 1px solid #B1B1B1;
}


.btn_space {
  height: 0;
}

@media (max-width: 768px) {
  .btn_space {
    height: 24px;
  }
}

.amount_text {
  font-family: Noto Sans TC;
  width: 64px;
  height: 24px;
  color: #333333;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

@media (max-width: 768px) {
  .amount_text {
    font-size: 18px;
    line-height: 1.2;
  }
}


</style>
